(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const sliders = document.querySelectorAll('.hero');
    sliders.forEach(slider => {
      const wrapper = slider.querySelector('.hero-slider-wrapper');
      const slides = slider.querySelectorAll('.hero-slide-item');
      const prevBtn = slider.querySelector('.hero-prev-btn');
      const nextBtn = slider.querySelector('.hero-next-btn');
      const dots = slider.querySelectorAll('.hero-dot');
      
      if (!wrapper || slides.length <= 1) return;

      let currentIndex = 0;
      const totalSlides = slides.length;

      function updateSlide() {
        wrapper.style.transform = `translateX(-${currentIndex * 100}%)`;
        
        dots.forEach((dot, index) => {
          if (index === currentIndex) {
            dot.style.width = '24px';
            dot.style.opacity = '1';
            dot.classList.add('active');
          } else {
            dot.style.width = '6px';
            dot.style.opacity = '0.5';
            dot.classList.remove('active');
          }
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          currentIndex = (currentIndex + 1) % totalSlides;
          updateSlide();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
          updateSlide();
        });
      }

      dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          currentIndex = parseInt(e.target.getAttribute('data-index'));
          updateSlide();
        });
      });

      // Auto slide every 5 seconds
      setInterval(() => {
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlide();
      }, 5000);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
